import * as React from 'react';
import { getRegionByVoteKey } from '@mentimeter/region';
import { voting } from '@mentimeter/http-clients';
import { useAppSelector } from '../redux-hooks';
import { voteKeySelector } from '../selectors';

export function useAudienceReconnect() {
  const voteKey = useAppSelector(voteKeySelector);

  const reconnect = React.useCallback(() => {
    if (!voteKey) return;
    const region = getRegionByVoteKey(voteKey);
    voting({ region }).audience.connect(voteKey);
  }, [voteKey]);

  return reconnect;
}
